export default {
  hladanyVyraz: '',
  cisloLegislativnehoMaterialu: '',
  identifikatorAktu: '',
  nazovLegislativnehoMaterialu: '',
  nazovAktu: '',
  medziinstitucionalnyKod: '',
  type: null,
  institucia: null,
  datumPrijatiaAktuOd: undefined,
  datumPrijatiaAktuDo: undefined,
};
